import React from "react";
import { IDestination } from "../../../../@types/IDestination";
import { Container, DestinationLink } from "./DestinationHelpers";

const Destination: React.FC<IDestination> = (props) => {
  return (
    <Container>
      <DestinationLink {...props} />
    </Container>
  );
};

export default Destination;
